function mobileNav(){
  $('.burger-icon').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.wrapper').toggleClass('reveal');
    $('.outer-wrapper').toggleClass('opened');
    $('html,body').animate({
      scrollTop: 0
    })
  })

  $('.wrapper .mobile-nav a').on('click', function(e) {
    const $this = $(this);
    const $dropDown = $this.next('ul');
    if ($dropDown.length) {
      e.preventDefault();
      $dropDown.slideToggle();
    }
  })
}

export default mobileNav();



// WEBPACK FOOTER //
// ../markup/assets/js/mobile-navigation.js